export default __webpack_public_path__ + "skype-logo.png";